/* Patırtı — Tozlu tarzı mega menü davranışı
   Masaüstü: nav linkine hover → panel açılır, sidebar hover → içerik değişir
   Mobil   : alt nav "Kategoriler" / hamburger / "Tüm Kategoriler" → tam ekran, sidebar dokun → içerik değişir */
(function () {
  'use strict';

  var mega = document.getElementById('ptMega');
  if (!mega) return;

  var mq = window.matchMedia('(min-width: 990px)');
  var nav = document.querySelector('.ty-nav');
  var content = mega.querySelector('.pt-mega__content');
  var sideItems = Array.prototype.slice.call(mega.querySelectorAll('[data-pt-target]'));
  var panels = Array.prototype.slice.call(mega.querySelectorAll('[data-pt-panel]'));
  var placeholder = document.createComment('pt-mega-anchor');
  var closeTimer = null;
  var lastTrigger = null;

  function isDesktop() {
    return mq.matches;
  }

  function isOpen() {
    return mega.getAttribute('aria-hidden') === 'false';
  }

  function firstIndex() {
    return sideItems.length ? sideItems[0].getAttribute('data-pt-target') : null;
  }

  // Verilen indeksin panelini göster, sidebar'da işaretle. Panel yoksa false döner.
  function activate(index) {
    if (index === null || index === undefined) return false;
    var key = String(index);
    var found = false;
    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-pt-panel') === key;
      panel.hidden = !on;
      if (on) found = true;
    });
    if (!found) return false;
    sideItems.forEach(function (li) {
      li.classList.toggle('is-active', li.getAttribute('data-pt-target') === key);
    });
    if (content) content.scrollTop = 0;
    return true;
  }

  function open(index, trigger) {
    if (!activate(index) && !activate(firstIndex())) return;
    mega.setAttribute('aria-hidden', 'false');
    lastTrigger = trigger || null;
    if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'true');
    if (!isDesktop()) {
      document.body.classList.add('pt-mega-open');
      var closeBtn = mega.querySelector('[data-pt-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
  }

  function close() {
    if (!isOpen()) return;
    mega.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pt-mega-open');
    if (lastTrigger && lastTrigger.setAttribute) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      if (!isDesktop()) lastTrigger.focus({ preventScroll: true });
    }
    lastTrigger = null;
  }

  // Mobilde <body> altına taşı: transform/filter'lı atalar position:fixed'i hapsetmesin.
  // Masaüstünde nav'ın içinde kalmalı (absolute konum nav'a göre).
  function relocate() {
    if (!isDesktop()) {
      if (mega.parentNode !== document.body) {
        mega.parentNode.insertBefore(placeholder, mega);
        document.body.appendChild(mega);
      }
    } else if (placeholder.parentNode) {
      placeholder.parentNode.insertBefore(mega, placeholder);
      placeholder.parentNode.removeChild(placeholder);
    }
    close();
  }
  relocate();
  if (mq.addEventListener) mq.addEventListener('change', relocate);
  else if (mq.addListener) mq.addListener(relocate);

  // ---------- Masaüstü: nav hover ----------
  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 150);
  }
  function cancelClose() {
    clearTimeout(closeTimer);
  }

  if (nav) {
    Array.prototype.forEach.call(nav.querySelectorAll('[data-pt-cat]'), function (li) {
      li.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelClose();
        var idx = li.getAttribute('data-pt-cat');
        if (!activate(idx)) {
          close(); // BLOG, KARGOM NEREDE? gibi panelsiz linkler
          return;
        }
        mega.setAttribute('aria-hidden', 'false');
      });
      li.addEventListener('mouseleave', function () {
        if (isDesktop()) scheduleClose();
      });
    });
  }
  mega.addEventListener('mouseenter', function () {
    if (isDesktop()) cancelClose();
  });
  mega.addEventListener('mouseleave', function () {
    if (isDesktop()) scheduleClose();
  });

  // ---------- Sidebar: masaüstünde hover ile, mobilde dokununca içerik değişir ----------
  sideItems.forEach(function (li) {
    var idx = li.getAttribute('data-pt-target');
    li.addEventListener('mouseenter', function () {
      if (isDesktop()) activate(idx);
    });
    li.addEventListener('click', function (e) {
      if (isDesktop()) return; // masaüstünde link normal çalışır
      e.preventDefault();
      activate(idx);
    });
  });

  // ---------- Mobil tetikleyiciler ----------
  // Capture aşamasında yakalayıp eski çekmece dinleyicilerine ulaşmasını engelliyoruz.
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var trigger = e.target.closest('#tyBnavCategories, #tyHamburgerBtn, #categoriesBtn');
      if (!trigger || isDesktop()) return;
      e.preventDefault();
      e.stopPropagation();
      if (isOpen()) close();
      else open(firstIndex(), trigger);
    },
    true
  );

  mega.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-pt-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });
})();
